import { mountReactComponents } from '../lib/react_mount.jsx';
const componentContext = import.meta.glob('../components/unauthenticated/*.tsx');
import Rails from '@rails/ujs';
Rails.start();

mountReactComponents(componentContext);
